import { LabelValueSet } from "../utility/LabelValueSet";

const DiureticType = Symbol();

export class Diuretic extends LabelValueSet  {
    [DiureticType]: any;

    static fromNothing(): Diuretic {
        return なし;
    }
}

const なし = new Diuretic("なし", "false");
const あり = new Diuretic("あり", "true");

export const diureticList: Diuretic[] = [
    なし,
    あり,
];

export const getDiureticFromValue = (value: boolean): Diuretic => {
    return value ? あり : なし;
};

export type DiureticJson = {
    diuretic: boolean
};

export const diureticInitialState = {
    diuretic: false
};
